export default function defaultText(defaultText: string) {
  return (text: string | undefined) => (text === "" ? defaultText : text)
}
